import {
    ADD_TO_CART_DETAILS
} from '../middleware/types'

const initialState = {
    SUBMIT_loading: false,
    error: {},
}

export default (state = initialState, action) => {
    switch (action.type) {
        case ADD_TO_CART_DETAILS:
            return {
                ...state,
                SUBMIT_loading: false,
                addedProductDetails : action.addedProductDetails,
               
            }
        default:
            return state
    }
}